import type { FilterPreset } from '../../shared/hooks/useFilterPresets';

/**
 * Pre-defined filter presets for the Therapeutic Areas page.
 *
 * Each preset maps to a named {@link FilterPreset} that the user can apply
 * with a single click via the FilterPresetControl.
 */
export const THERAPEUTIC_AREA_PRESETS: FilterPreset[] = [
  {
    id: 'ta_all',
    label: 'All Therapeutics',
    description: 'Show all therapeutic areas with no filters applied',
    query: {
      groupOperator: 'AND',
      filterGroups: [],
    },
  },
];
